import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { COLORS } from '../styles/colors';
import Modal from '@material-ui/core/Modal';
import ModalHeading from './ModalHeading';
import { EditExercise } from '../containers/Exercises';
export default class EditExerciseButton extends Component {

	state = {
		open: false
	};

	render() {

    const { exercise } = this.props;
    const { open } = this.state;
		return (
			<div>
	    	<Modal
	        className="modal show"
	        open={open}
	        onClose={() => this.setState({open:false})}>
	        <div className="modalBody modal-content" style={{width:1050, maxHeight: '90%', overflow: 'auto'}}>
						<ModalHeading
							text={(
								<div>
									<FontAwesomeIcon icon="edit"
										style={{marginRight: 5, color: COLORS.orange}}/>
									<span>{exercise.name}</span>
								</div>

							)}
							closeModal={() => this.setState({...this.state, open: false})}/>
						<div className="modalContent">
							<EditExercise exercise={exercise} editId={exercise._id} hideNavigationTabs={true} onClose={() => this.setState({ open: false })}  />
						</div>
	        </div>
	      </Modal>
		    <span
          className="link"
          onClick={() => this.setState({open:true})}
          style={{float:'right'}}>
          <FontAwesomeIcon icon="edit" title={'Edit'}
            style={{marginRight: 5, color: COLORS.orange}}/>
        </span>
			</div>
    );
	}
}



// WEBPACK FOOTER //
// ./src/components/EditExerciseButton.js